import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useHistory } from 'react-router-dom';


type path ={
  label: string,
  path: string,
  queries: {}
}
type BreadCrumbProps = {
    finalCrumb:string,
    prevCrumb: path[]
}
export const BreadCrumb: React.FC<BreadCrumbProps> = ({finalCrumb: siteName, prevCrumb}) =>{
  const history = useHistory();

  function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, previous: any) { 
    const path = previous.path;
    const queries = previous.queries;
    let isBreadcrumbFlag = true;
    history.push({
      pathname:path, 
      key: path,
      state: {
        isFromBreadcrumb: isBreadcrumbFlag,
        queries: queries
      }
    })
    event.preventDefault();
  }

  function previousCrumb(){
    const prev= prevCrumb.map((previous, index)=>{
        return(
          <Link key={`${previous.label}-${index}`} style={{ color:'#1a6ad3', fontWeight: 700, textTransform: 'uppercase' }} href={previous.path} onClick={(e)=>{handleClick(e, previous)}} >
            {previous.label}
          </Link>
        )
    });
    return prev;
  }

  const breadcrumbs = [
    previousCrumb(),
    <Typography key="3" style={{ color:'#707070', fontWeight: 700, textTransform: 'uppercase' }}>
      {/* //TODO Rename to accomodate new groupName now */}
      {siteName} 
    </Typography>,
  ];

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}